import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from './base-data-service';
import { AvailableDocument,GetSLDocumentReq } from './def/steps';
import {
  DownloadDocumentRequest,
  DownloadDocumentResponse
} from './def/document';
import { DocumentAPIPath, FileType } from '@tmhcc-ng-lib/models';
import { GlobalVariablesService } from './global-variables.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
@Injectable({
  providedIn: 'root'
})
export class DocumentService extends BaseDataService {
  loaded: boolean;
  data;
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }

  downloadApplication(
    payload: DownloadDocumentRequest
  ): Observable<DownloadDocumentResponse> {
    const url = `${this.serviceBaseUrl}/document/download-application/${payload.policyId}/${payload.versionNum}`;
    return this.get<DownloadDocumentResponse>(url);
  }

  downloadQuote(
    payload: DownloadDocumentRequest
  ): Observable<DownloadDocumentResponse> {
    const url = `${this.serviceBaseUrl}/document/download-indication-application/${payload.policyId}/${payload.versionNum}`;
    return this.get<DownloadDocumentResponse>(url);
  }

  downloadLossRun(
    payload: DownloadDocumentRequest
  ): Observable<DownloadDocumentResponse> {
    const url = `${this.serviceBaseUrl}/document/download-loss-run/${payload.policyId}/${payload.versionNum}/${payload.lossRunType}`;
    return this.get<DownloadDocumentResponse>(url);
  }

  downloadQuoteProposalApplication(
    payload: DownloadDocumentRequest
  ): Observable<DownloadDocumentResponse> {
    const url = `${this.serviceBaseUrl}/document/download-quote-proposal-application/${payload.policyId}/${payload.versionNum}`;
    return this.get<DownloadDocumentResponse>(url);
  }

  downloadQuoteProposalDocument(
    payload: DownloadDocumentRequest
  ): Observable<DownloadDocumentResponse> {
    const url = `${this.serviceBaseUrl}/document/download-quote-proposal/${payload.policyId}/${payload.versionNum}`;
    return this.get<DownloadDocumentResponse>(url);
  }

  downloadPdfData(endpointUrl: string,payload:any=null): Observable<any> {
    const url = `${this.serviceBaseUrl + endpointUrl}`;
    // const url = "http://localhost:51806" + endpointUrl;  
    if(!payload){      
      return this.get<any>(url);
    }
    else {
      return this.post<any>(url, { body: payload });
    }
  }

  previewSLApplication(
    payload: DownloadDocumentRequest
  ): Observable<DownloadDocumentResponse> {
    const url = `${this.serviceBaseUrl}/document/download-sl-form/${payload.policyId}/${payload.versionNum}/${payload.ucmFormId}`;
    return this.get<DownloadDocumentResponse>(url);
  }

  generateEndpoint(
    doc: AvailableDocument,
    policyId: number,
    versionNum: number
  ): string {
    let endpoint = '';
    switch (doc.ApiPath) {
      case DocumentAPIPath.DownloadApplication:
        endpoint = `${DocumentAPIPath.DownloadApplication}/${policyId}/${versionNum}/${doc.PaymentPlanId}`;
        break;
      case DocumentAPIPath.DownloadCOI:
        endpoint = `${DocumentAPIPath.DownloadCOI}/${policyId}/${versionNum}`;
        break;
      case DocumentAPIPath.DownloadDocument:
        endpoint = `${DocumentAPIPath.DownloadDocument}/${doc.ImageRightPageId}`;
        break;
      case DocumentAPIPath.DownloadIndicationApp:
        endpoint = `${DocumentAPIPath.DownloadIndicationApp}/${policyId}/${versionNum}`;
        break;
      case DocumentAPIPath.DownloadQuote:
        endpoint = `${DocumentAPIPath.DownloadQuote}/${policyId}/${versionNum}`;
        break;
      case DocumentAPIPath.DirectBill:
        endpoint = `${DocumentAPIPath.DirectBill}/${policyId}/${versionNum}`;
        break;
      ///document/download-direct-bill-notice/{policy-id}/{version-number}
      case DocumentAPIPath.DownloadQuoteApp:
        if (doc.PaymentPlanId) {
          endpoint = `${DocumentAPIPath.DownloadQuoteApp}/${policyId}/${versionNum}/${doc.PaymentPlanId}`;
        } else {
          endpoint = `${DocumentAPIPath.DownloadQuoteApp}/${policyId}/${versionNum}`;
        }
        break;
      case DocumentAPIPath.DownloadSLForm:
        endpoint = `${DocumentAPIPath.DownloadSLForm}/${policyId}/${versionNum}/${doc.UCMFormId}`;
        break;
      case DocumentAPIPath.DownloadSLFormByFormName:
        endpoint = `${DocumentAPIPath.DownloadSLFormByFormName}`;
        break;
      default:
        endpoint = 'endpoint-not-found';
        break;        
    }
    return endpoint;
  }

  generatePayload(
    doc: AvailableDocument,
    policyId: number,
    versionNum: number,
    docName:string = null
  ): any {
     let payload: GetSLDocumentReq = { PolicyId: policyId, VersionNum: versionNum } ;
    switch (doc.ApiPath) {      
      case DocumentAPIPath.DownloadSLFormByFormName:
        payload.FormName = docName;
        break;
      default:
        payload = null;
        break;        
    }
    return payload;
  }
  openBase64NewTab(base64Pdf: string): void {
    var blob = this.base64toBlob(base64Pdf, FileType.PDF);
    let nevigator: any = window.navigator;
    if (nevigator && nevigator.msSaveOrOpenBlob) {
      nevigator.msSaveOrOpenBlob(blob, 'document.pdf');
    } else {
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl);
    }
  }

  openDocumentByUrl(documentUrl: string) {
    window.open(documentUrl);
  }
  private base64toBlob(base64Data: string, fileType: string) {
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);

      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    if (fileType === FileType.PDF) {
      return new Blob(byteArrays, { type: 'application/pdf' });
    } else if (fileType === FileType.XLSX) {
      return new Blob(byteArrays, {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
    }
  }

  downloadPdf(base64Pdf, fileName) {
    let nevigator: any = window.navigator;
    if (nevigator && nevigator.msSaveOrOpenBlob) {
      // download PDF in IE
      var blob = this.base64toBlob(base64Pdf, FileType.PDF);
      nevigator.msSaveOrOpenBlob(blob, `${fileName}.pdf`);
    } else {
      // Download PDF in Chrome etc.
      const source = `data:application/pdf;base64,${base64Pdf}`;
      const link = document.createElement('a');
      link.href = source;
      link.download = `${fileName}.pdf`;
      link.click();
    }
  }
  downloadExcelFromBase64(base64Pdf, fileName) {
    let nevigator: any = window.navigator;
    if (nevigator && nevigator.msSaveOrOpenBlob) {
      // download PDF in IE
      var blob = this.base64toBlob(base64Pdf, FileType.XLSX);
      nevigator.msSaveOrOpenBlob(blob, `${fileName}.xlsx`);
    } else {
      // Download PDF in Chrome etc.
      const source = `data:application/xls;base64,${base64Pdf}`;
      const link = document.createElement('a');
      link.href = source;
      link.download =
        fileName + '_export_' + new Date().getTime() + '.' + FileType.XLSX;
      link.click();
    }
  }

  exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data']
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: FileType.XLSX,
      type: 'array'
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(
      data,
      fileName + '_export_' + new Date().getTime() + '.' + FileType.XLSX
    );
  }
}
